import { getCaseDetails } from './fetchApi'
import { caseActions } from '../store/case'
import { filterActions } from '../store/filter'

export const transportationFunctions = {
    isTransportationFundsRemainingBelowMinimum: (caseData) => {
        if (caseData && caseData.case_flag && caseData.case_flag.trans_funds_lt_one_rt) {
            return 'bk_Red'
        }

        if (caseData && caseData.case_flag && caseData.case_flag.trans_funds_lt_two_rt) {
            return 'bk_Orange'
        }

        return null
    },

    /** Sync client_number on active case (and work-queue row) after agreement PDF generation. */
    async refreshClientNumberAfterAgreement(token, caseId, dispatch, inWorkQ) {
        const caseDetail = await getCaseDetails(token, caseId)
        if (!caseDetail || caseDetail.errorMessage || caseDetail.status) {
            return caseDetail
        }

        const clientNumber = caseDetail?.case_transportation?.client_number
        if (!clientNumber) {
            return null
        }

        const dispatchObj = {
            folder: 'case_transportation',
            item: {
                fields: [{ field: 'client_number', value: clientNumber }],
            },
        }
        dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))

        if (inWorkQ?.case?.id) {
            dispatch(filterActions.updateItemInWorkQRow({
                case_id: inWorkQ.case.id,
                ...dispatchObj,
            }))
        }

        return clientNumber
    },
}

const APPOINTMENT_RESCHEDULED_MESSAGE = "This appointment was rescheduled"

const collectErrorText = (value) => {
    if (value == null) {
        return []
    }
    if (Array.isArray(value)) {
        return value.flatMap(collectErrorText)
    }
    if (typeof value === "string") {
        const trimmed = value.trim()
        return trimmed ? [trimmed] : []
    }
    if (typeof value === "object") {
        return Object.values(value).flatMap(collectErrorText)
    }
    return [`${value}`.trim()].filter(Boolean)
}

export const isAppointmentRescheduledError = (payload) => {
    const source = payload?.errorMessage ?? payload
    return collectErrorText(source).some((message) => message.includes(APPOINTMENT_RESCHEDULED_MESSAGE))
}